var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container"},[_vm._v("LYEdge")])
}
var staticRenderFns = []

export { render, staticRenderFns }